import { useState, useMemo } from 'react'
import { Dialog, Button, Icon, Grid, Typography } from '@material-ui/core'
import same from 'lodash/identity'
import isFunction from 'lodash/isFunction'
import merge from 'lodash/merge'

import { reactSwitch } from 'utils/utils'

export const ICON_SUCCESS_COLOR = '#28a745'
export const ICON_WARNING_COLOR = '#F0A71E'
export const ICON_INFO_COLOR = '#007bff'
export const ICON_ERROR_COLOR = '#DC3545'

const color = value =>
   reactSwitch(value, {
      success: ICON_SUCCESS_COLOR,
      warning: ICON_WARNING_COLOR,
      info: ICON_INFO_COLOR,
      error: ICON_ERROR_COLOR,
      default: value
   })

const iconMap = value =>
   reactSwitch(value, {
      success: 'check_circle',
      warning: 'warning',
      info: 'info',
      error: 'cancel',
      default: value
   })

export const initialModalState = {
   message: '',
   icon: 'error',
   // iconColor: 'warning',
   onConfirm: same,
   onDeny: null,
   confirmButtonText: 'Sí',
   closeButtonText: 'No',
   denyButtonText: 'Negar',
   hideCloseButton: false,
   title: '',
   style: { maxWidth: 354 }
}

const buttonMaxWidth = { maxWidth: '50%' }

export const usePortalModal = () => {
   const [params, setParams] = useState(initialModalState)
   const setModal = parameters => setParams({ ...parameters })
   const onClose = () => setParams(initialModalState)
   return { params, onClose, setModal }
}

const PortalModal = ({ params = { ...initialModalState }, onClose, children }) => {
   const parameters = useMemo(() => merge({ ...initialModalState }, params), [params])

   const value = params?.value

   const handleConfirm = async () => {
      await parameters?.onConfirm?.(value)
      onClose()
   }
   const handleDeny = async () => {
      await parameters?.onDeny?.(value)
      onClose()
   }

   return (
      <Dialog open={Boolean(parameters?.message) || Boolean(parameters?.title)} onClose={onClose}>
         <Grid container direction="column" alignItems="center" style={{ padding: '38px 50px 30px' }}>
            {parameters?.icon && (
               <Icon style={{ fontSize: 80, color: color(parameters?.iconColor ?? parameters?.icon) }}>
                  {iconMap(parameters?.icon)}
               </Icon>
            )}
            {parameters?.title && (
               <Grid container justifyContent="center" style={{ margin: '10px 0' }}>
                  <Typography variant="h6">{parameters?.title}</Typography>
               </Grid>
            )}
            <Grid
               style={{
                  margin: '15px auto',
                  fontWeight: 500,
                  fontSize: 15,
                  textAlign: 'center',
                  ...parameters?.style
               }}
            >
               {parameters?.message}
            </Grid>
            {params?.children ?? children}
            <Grid
               container
               spacing={2}
               justifyContent="center"
               alignItems="center"
               wrap="nowrap"
               style={{
                  margin: '18px auto 0px',
                  gap: '10px',
                  ...parameters?.style
               }}
            >
               <Button
                  style={buttonMaxWidth}
                  disableElevation
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={handleConfirm}
               >
                  {parameters?.confirmButtonText}
               </Button>

               {isFunction(parameters?.onDeny) && (
                  <Button disableElevation fullWidth onClick={handleDeny}>
                     {parameters?.denyButtonText}
                  </Button>
               )}
               {!parameters?.hideCloseButton && (
                  <Button disableElevation fullWidth variant="outlined" color="primary" onClick={onClose}>
                     {parameters?.closeButtonText}
                  </Button>
               )}
            </Grid>
         </Grid>
      </Dialog>
   )
}

export default PortalModal
